'use client';

import type {DetailPageAnalytics} from '../../analytics';
import {AmenitiesSection} from '../amenities';
import type {DetailModals} from './useDetailModals';

export interface DetailAmenitiesProps {
  item: {uuid: string; name: string; amenities: {icon: string; label: string}[]};
  analytics: DetailPageAnalytics;
  modals: DetailModals;
}

export function DetailAmenities({item, analytics, modals}: DetailAmenitiesProps) {
  if (item.amenities.length === 0) {
    return null;
  }
  const tracked = {id: item.uuid, name: item.name};
  return (
    <AmenitiesSection
      items={item.amenities}
      onViewAll={
        modals.amenitiesOverflow
          ? () => {
              analytics.viewAll(tracked, 'amenities');
              modals.openAmenities();
            }
          : undefined
      }
    />
  );
}

DetailAmenities.displayName = 'DetailAmenities';
